import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export type OrganizationMatch = {
  id: string;
  name: string;
  isEnterprise: boolean;
  subscriptionConfigured: boolean;
};

type SearchOrganizationsPayload = {
  query: string;
};

type SearchOrganizationsResponse = {
  organizations: OrganizationMatch[];
};

export async function searchOrganizations(query: string): Promise<OrganizationMatch[]> {
  if (query.trim().length < 3) {
    return [];
  }

  const callable = httpsCallable<SearchOrganizationsPayload, SearchOrganizationsResponse>(
    functions,
    'searchOrganizations',
  );
  const result = await callable({ query });
  return Array.isArray(result.data?.organizations) ? result.data.organizations : [];
}
